import HeaderPage from "../../components/HeaderPage";
import styles from "./UsersPage.module.css";
import { useState, useEffect } from "react";
import User from "../../components/User";
import { UserRoundCog, CircleCheckBig } from "lucide-react";
import MiniCardUser from "../../components/MiniCardUser";
import FormUser from "../../components/FormUser";
import SearchBar from "../../components/SearchBar";
import FormUserEdit from "../../components/FormUserEdit";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { check, getUsers, ativoEdit } from "../../api/users.api";
import { useNavigate } from "react-router-dom";
import AlertUser from "../../components/AlertUser";

function UsersPage() {
    const [data, setData] = useState([]);
    const [isOpen, setIsOpen] = useState(false)
    const [search, setSearch] = useState("");
    const [isOpenEdit, setIsOpenEdit] = useState(false)
    const [thisUser, setThisUser] = useState({})
    const [isOpenEditActive, setIsOpenEditActive] = useState(false)

    function executarAlerta(mensagem) {
        return toast.success(mensagem);

    }

    function sendDataToFormEdit(user) {
        setIsOpenEdit(true)
        setThisUser(user);
    }

    function sendDataToFormEditActive(user) {
        setIsOpenEditActive(true)
        setThisUser(user);
    }



    const navigate = useNavigate()


    useEffect(() => {
        check()
            .then((response) => {
                if(response.data.cargo != "Admin") navigate("/tickets")
                getUsers()
                    .then(res => setData(res.data))
                    .catch((error) => {
                        setData([]);
                        if (error.response.status === 401) {
                            return toast.error("Não autorizado!");
                        } else if (error.response.status != 200) {
                            return toast.error("Erro! Verificar com suporte");
                        }
                    })
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    navigate("/login")
                } else if (error.response.status != 200) {
                    navigate("/login")
                    return toast.error("Erro! Verificar com suporte");
                }
            })

    }, []);

    const filteredUsers = Array.isArray(data) ? data.filter(user =>
        user.name.toLowerCase().includes(search.toLowerCase()) ||
        user.userName.toLowerCase().includes(search.toLowerCase()) ||
        user.departamento.toLowerCase().includes(search.toLowerCase()) ||
        user.cargo.toLowerCase().includes(search.toLowerCase()))
        : []

    return (
        <main className={styles.container}>
            <section className={styles.containerOne}>
                <HeaderPage
                    title="Usuários"
                    textTitle="Gerencie os acessos ao sistema"
                    textBtn="Usuário"
                    setIsOpen={() => setIsOpen(true)}
                />
                <div className={styles.cards}>
                    <MiniCardUser
                        text="Total"
                        icon={<UserRoundCog size={16} color="#f97015" />}
                        data={data.length}
                    />
                    <MiniCardUser
                        text="Ativos"
                        icon={<CircleCheckBig size={16} color="hsl(142 71% 45%)" />}
                        data={
                            Array.isArray(data)
                                ? data.filter(user => user.emailConfirmed).length
                                : 0
                        }
                    />
                </div>
                <SearchBar setSearch={setSearch} />
            </section>
            <section className={styles.containerTwo}>
                {filteredUsers.map((item) => (
                    <User
                        thisUser={item}
                        setIsOpenEdit={sendDataToFormEdit}
                        setIsOpenEditActive={sendDataToFormEditActive}
                    />
                ))}
            </section>


            {isOpen && (
                <FormUser setIsOpen={setIsOpen} />
            )}

            {isOpenEdit && (
                <FormUserEdit setIsOpen={setIsOpenEdit} thisUser={thisUser} />
            )}

            {isOpenEditActive && (
                <AlertUser setIsOpen={setIsOpenEditActive} entity={thisUser} func={ativoEdit} />
            )}
        </main>
    )
}

export default UsersPage;